import Tooltip from '@mui/material/Tooltip';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall } from '../CommonComponents/CustomHooks';
import { copyToClipboard } from '../CommonComponents/EnvConfig';
import Loader from '../CommonComponents/Loader';

const SuccessStatus = () => {    const location = useLocation();    const queryParams = new URLSearchParams(location.search);    const myParam = queryParams.get('Token');    const HeaderIDLocal = window.localStorage.getItem('HeaderID');    const OnlinePaymentID = window.localStorage.getItem('OnlinePaymentID');    const [subLoading, setSubLoading] = useState(false)    const paymentID = queryParams.get('OnlinePaymentID');    const [pageDisplay, setPageDisplay] = useState(false)
    const [message, setMessage] = useState(false);    const [customMessage, setCustomMessage] = useState(false);    const [PayBy, setPayBy] = useState('');    const navigate = useNavigate()

    const [isFocused, setIsFocused] = useState(false);
    const [copyStatus, setCopyStatus] = useState(false)    useEffect(() => {
        if (copyStatus) {
            setTimeout(() => {
                setCopyStatus(false)
            }, 1000)
        }
    }, [copyStatus])
    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };    const handleCheckResponse = async () => {
        const requestData = {
            "OnlinePaymentID": paymentID,
            "headerID": HeaderIDLocal
        }
        try {
            await (setSubLoading(true))
            const data = await ApiCall('/api/SalesEntryAPI/CheckPaymentStatus', requestData)
            if (data.status === 'SUCCESS') {
                if (data?.paymentDataResponse?.statusCode === '00') {
                    await handleSubmitRef()
                }
            } else {
                await (setSubLoading(false))
                await NotificationSound(data.status, data.message);
            }
        } catch (error) {
            await (setSubLoading(false))
            console.error('Error in payment process:', error);
        }
    };

    const handleNavigate = () => {
        navigate('Dashboard/DealerDashboard')
    };
    const handleSubmitRef = async () => {
        await (setSubLoading(true))
        let data = await ApiCall(`/api/SalesEntryAPI/GeneratePolicyNo`, { HeaderID: HeaderIDLocal, OnlinePaymentID: paymentID })
        await (setSubLoading(false))
        setMessage(data.message)

        //For Custom Policy Message
        if (data.status === 'SUCCESS') {
            setCustomMessage(true)
        } 
    };    const Validate = async () => {        await (setSubLoading(true))        let data = await ApiCall('/api/SalesEntryAPI/CheckPageStatus', { Token: myParam, OnlinePaymentID: paymentID })
        await (setSubLoading(false))
        if (data.status === 'SUCCESS') {
            setPayBy(data.payBy)
            await setPageDisplay(true)
        }
    }    useEffect(() => {        Validate()
    }, [])    useEffect(() => {        setCustomMessage(false)        if (OnlinePaymentID && pageDisplay) {            handleCheckResponse()
        }
        
    }, [pageDisplay])    return (        <>            {subLoading && <Loader />}            {pageDisplay ?                <section className="py-3">                    <div className="container">
                        <div className="col-12">
                            <div className="main-card rounded-0 p-4 d-flex flex-column justify-content-center" style={{ height: '72vh' }}>
                                <div className="d-flex align-items-center flex-column text-center">
                                    <div className="thankyou-img">                                        <img                                            src="./images/thank-you.png"                                            className="img-fluid"                                            style={{ maxWidth: 150 }}                                            alt='...'                                        />
                                        <div className="thankyou-text mt-3">                                            <h3 className="text-success fw-bold">{"SUCCESS"}</h3>                                            <p>                                                <span className='fs-6'>{"Your payment was successful! Thank you for your purchase.!"}</span>                                            </p>                                        </div>
                                        <p className='m-0 mb-1' style={{ fontSize: '14px', fontFamily: 'sans-serif', fontWeight: 600, lineHeight: '1.2' }}>

                                            {message && (() => {
                                                const [beforeBrackets, rest] = message.split('[');
                                                if (!rest) return <>{message}</>;

                                                const [textToCopy, afterBrackets] = rest.split(']');
                                                if (!afterBrackets) return <>{message}</>;

                                                return (
                                                    <>
                                                        {`${beforeBrackets} [`}
                                                        <Tooltip
                                                            title={copyStatus ? 'Copied!' : 'Copy to clipboard!'}
                                                            arrow
                                                            componentsProps={{
                                                                arrow: { sx: { color: "#5D3FD3" } },
                                                                tooltip: { sx: { color: "white", backgroundColor: "#5D3FD3" } }
                                                            }}
                                                        >
                                                            <span
                                                                style={{ color: '#799EDE', cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    setCopyStatus(true);
                                                                    copyToClipboard(textToCopy.trim());
                                                                }}
                                                            >
                                                                {textToCopy.trim()}
                                                            </span>
                                                        </Tooltip>
                                                        {` ]${afterBrackets}`}
                                                    </>
                                                );
                                            })()}
                                        </p>
                                        {customMessage &&
                                            <p className='m-0 mb-1' style={{ fontSize: '14px', fontFamily: 'sans-serif', fontWeight: 600, lineHeight: '1.2' }}>
                                                Your policy copy will be sent to your registered email and mobile within 48 working hours
                                            </p>
                                        }
                                        
                                        <hr style={{
                                            marginTop: "1rem",
                                            marginBottom: "1rem",
                                            borderWidth: "0",
                                            borderTop: "1px solid #F5F5F5"
                                        }}></hr>

                                        <>
                                            {PayBy === 'DEALER' && (
                                            <div className="col-12 d-flex justify-content-center gap-3 flex-row flex-wrap" >
                                                <div className="d-flex flex-column justify-content-center align-items-center px-4 finalBook"

                                                    style={{
                                                        backgroundColor: "green", width: "128px", borderRadius: "4px", cursor: "pointer", paddingTop: '10px',
                                                        boxShadow: isFocused && "2px 2px 8px #E05D4D"
                                                    }}
                                                    onClick={() => {
                                                        handleNavigate(false)
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            handleNavigate(false)
                                                        }
                                                    }}
                                                    onFocus={handleFocus}
                                                    onBlur={handleBlur}
                                                    tabIndex={0}
                                                >
                                                    {/* <IoMdAdd style={{ color: "white", fontSize: "23px", marginTop: "8px", fontWeight: "bolder" }} />*/}
                                                    <p style={{ color: "white", fontSize: "12px", fontWeight: 'bold' }}> Go To Home</p>
                                                </div>
                                            </div>
                                            )}

                                        </>

                                    </div>
                                </div>
                            </div>
                        </div>                    </div>                </section>                : <section className="py-3">                    <div className="container">                        <div className="row pt-5">                            <div className="col-12 mb-5 text-center">                                <div className="thankyou-img">                                    <img src="./images/404.jpg" className="img-fluid" alt='' />                                </div>                                <div className="thankyou-text mt-5">                                    <h3 className="main-heading h2">Page not found</h3>                                    <p className='fs-6'>you are unauthorized for this action <br /> please review the following url and make sure that It is spelled correctly.</p>                                </div>                            </div>                        </div>                    </div>                </section>}        </>    )}export default SuccessStatus;